/**
 * 获取ws连接地址
 *
 * @export
 * @returns
 */
export function getWsUrl() {
    return `${location.protocol === "http:" ? "ws" : "wss"}://${
        location.host
    }/websocket`;
}

/**
 * 获取token值
 *
 * @export
 * @returns
 */
export function getToken() {
    return $cookies.get("WEB-SESSION") || $cookies.get("token") || "";
}

/**
 * 获取浏览器语言
 *
 * @export
 * @returns
 */
export function navigatorLang() {
    let lang = "";
    if (navigator.hasOwnProperty("language") && navigator.language) {
        lang = navigator.language.toLowerCase();
    }
    switch (lang) {
        //英文
        case "en-us":
        case "en":
            return "en_US";
        //中文繁体
        case "zh-tw":
            return "zh_TW";
        //韩文
        case "ko-kr":
        case "ko":
            return "ko_KR";
        //越南文
        case "vi-vw":
        case "vi":
            return "vi_VN";
        case "id-id":
            return "id_ID";
        //越南文
        case "tr-tr":
        case "tr":
            return "tr_TR";
        case "ru-ru":
            return "ru_Ru";
            // 法文
        case "fr":
            return "fr_FR";
            // 法文
        case "fr-fr":
            return "fr_FR";
        //其他：中文简体
        default:
            return "zh_CN";
    }
}



// WEBPACK FOOTER //
// ./src/common/ts/environment.ts